module.exports = __webpack_public_path__ + "img/icon-netflix.4ebd733e.svg";